export const SET_USERS_TO_INVITE = 'SET_USERS_TO_INVITE';
export const IS_FETCHING_USERS_TO_INVITE = 'IS_FETCHING_USERS_TO_INVITE';

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';

export const SET_MODAL_STAGE = 'SET_MODAL_STAGE';
